'use client'

import React from 'react'
import Image from 'next/image'
import { useModal } from '@/blocks/redesign_blocks/Modal/ModalContext'
import AnimatedSection from '@/components/AnimatedSection'
import Typography from '@/components/Typography'
import styles from './styles.module.css'

const Main: React.FC = () => {
	const { openConsultationModal } = useModal()

	return (
		<section className={styles.section}>
			<AnimatedSection animation='slideUp'>
				<div className={styles.content}>
					<Typography variant='h1' className={styles.title}>
						True.pay B2C — сервис безопасных выплат физлицам с бизнес-карт
					</Typography>
					<Typography variant='p1' color='description' className={styles.description}>
						Выплачивайте деньги клиентам и подрядчикам за секунды напрямую с бизнес-карты. Распределяйте роли, защитите главный счёт компании от операционных рисков и забудьте о сложных банковских интерфейсах.
					</Typography>
					<button className={styles.button} onClick={openConsultationModal}>
						<span className={styles.buttonText}>Получить консультацию</span>
						<svg className={styles.buttonIcon} viewBox='0 0 16 16' fill='none'>
							<path d='M6.33333 3V4.33333H10.7267L3 12.06L3.94 13L11.6667 5.27333V9.66667H13V3H6.33333Z' fill='white' />
						</svg>
					</button>
				</div>
			</AnimatedSection>
			<AnimatedSection animation='slideUp'>
				<div className={styles.imageContainer}>
					<Image
						src='/images/b2c/main_desktop.svg'
						alt='Система управления конкурентными листами'
						width={1110}
						height={330}
						className={styles.desktopImage}
						unoptimized
					/>
					<Image
						src='/images/b2c/main_tablet.svg'
						alt='Система управления конкурентными листами'
						width={680}
						height={283}
						className={styles.tabletImage}
						unoptimized
					/>
					<Image
						src='/images/b2c/main_mobile.svg'
						alt='Система управления конкурентными листами'
						width={328}
						height={184}
						className={styles.mobileImage}
						unoptimized
					/>
				</div>
			</AnimatedSection>
		</section>
	)
}

Main.displayName = 'Main'

export default Main
